export const getFormattedNumber = (number, locale) => {
    if (number === null || number === undefined || Number.isNaN(number)) {
        return '-';
    }
    const absValue = Math.abs(number);
    if (absValue >= 10000) {
        const formatter = new Intl.NumberFormat(locale, {
            style: 'decimal',
            notation: 'compact',
            compactDisplay: 'short',
        });
        return formatter.format(number).toLowerCase();
    }
    const formatter = new Intl.NumberFormat(locale, {
        style: 'decimal',
        maximumFractionDigits: 2,
    });
    return formatter.format(number);
};
